import React, { useState } from 'react';
import { createProject } from '../api/client';
import { WorkType, Domain } from '../../lib/types';

export default function NewIdea({ onSubmitSuccess, onCancel }: {
  onSubmitSuccess: () => void;
  onCancel: () => void;
}) {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    domain: 'product' as Domain,
    workType: 'Product' as WorkType,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const domains: Domain[] = ['infrastructure', 'networking', 'voice', 'product', 'development'];
  const workTypes: WorkType[] = ['Product', 'NonProduct'];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Get current user (for MVP, hardcoded; would come from auth)
      const userEmail = 'test@example.com';
      const userName = 'Test User';

      const response = await createProject({
        title: formData.title,
        description: formData.description,
        domain: formData.domain,
        workType: formData.workType,
        createdByEmail: userEmail,
        createdByName: userName,
      });

      if (response.success) {
        onSubmitSuccess();
      } else {
        setError(response.error || 'Failed to submit idea');
      }
    } catch (err: any) {
      setError(err.message || 'Error submitting idea');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Submit New Idea</h2>
        <form onSubmit={handleSubmit}>
          {/* Title */}
          <div className="form-group">
            <label htmlFor="title">Title *</label>
            <input
              id="title"
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="What is this idea?"
              required
              maxLength={200}
            />
          </div>

          {/* Description (Idea) */}
          <div className="form-group">
            <label htmlFor="description">Idea *</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Describe the idea and why it matters"
              rows={4}
              required
            />
          </div>

          {/* Domain (Area) */}
          <div className="form-group">
            <label htmlFor="domain">Area *</label>
            <select name="domain" id="domain" value={formData.domain} onChange={handleChange} required>
              {domains.map(d => (
                <option key={d} value={d}>{d}</option>
              ))}
            </select>
          </div>

          {/* Work Type (for routing) */}
          <div className="form-group">
            <label htmlFor="workType">Type *</label>
            <select name="workType" id="workType" value={formData.workType} onChange={handleChange} required>
              {workTypes.map(w => (
                <option key={w} value={w}>{w === 'Product' ? 'Product Initiative' : 'Internal/Non-Product'}</option>
              ))}
            </select>
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="form-actions">
            <button type="submit" disabled={loading} className="btn-primary">
              {loading ? 'Submitting...' : 'Submit Idea'}
            </button>
            <button type="button" onClick={onCancel} className="btn-secondary">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
